import { useTranslation } from "react-i18next";

import { Icons } from "../../utils";
import { BoxWithDividerLines } from "../BoxWithDividerLines";
import { IconType } from "../Icon";
import { RowWithIconContainer } from "../RowWithIconContainer/RowWithIconContainer";

import { ContentWithTitle } from "../ContentWithTitle";
import { formatCurrency } from "../../utils/currency";
import { Box } from "../Box";
import { BillingPaymentsHistory } from "../../types/billing";

type BillingHistoryListProps = {
  history: BillingPaymentsHistory[];
};

export const BillingHistoryList: React.FC<BillingHistoryListProps> = ({ history }) => {
  const { t } = useTranslation();

  const controlBoxItems = history.map(({ year, amount }, index) => ({
    id: index,
    element: (
      <RowWithIconContainer
        iconName={Icons.calendar}
        iconType={IconType.gray}
        mainText={year.toString()}
        secondaryText={t(`billing.billingHistoryList.chargedFeeTitle`, {
          amount: formatCurrency(amount),
        })}
        style={{ height: "3rem" }}
      />
    ),
  }));

  return (
    <ContentWithTitle title={t("billing.billingHistoryList.title")}>
      {history.length === 0 && <Box>{t("billing.billingHistoryList.noHistory")}</Box>}
      {history.length > 0 && (
        <BoxWithDividerLines
          style={{ padding: "0.8rem", paddingLeft: "1rem", overflow: "hidden" }}
          items={controlBoxItems}
        />
      )}
    </ContentWithTitle>
  );
};
